import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import ServicesPage from './pages/Services';
import AboutPage from './pages/About';
import ContactPage from './pages/Contact';
import HistoryPage from './pages/History';
import MultiservicosPage from './pages/Multiservicos';
import ResultsPage from './pages/Results';
import CommitmentPage from './pages/Commitment';
import NotFoundPage from './pages/NotFound';
import RouteEffects from './components/RouteEffects';

function App() {
  return (
    <Router>
      <div className="App">
        <RouteEffects />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/servicos" element={<ServicesPage />} />
          <Route path="/sobre" element={<AboutPage />} />
          <Route path="/contato" element={<ContactPage />} />
          <Route path="/historia" element={<HistoryPage />} />
          <Route path="/multiservicos" element={<MultiservicosPage />} />
          <Route path="/resultados" element={<ResultsPage />} />
          <Route path="/compromisso" element={<CommitmentPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
